import React, { Component } from 'react';

export default class extends Component {
    state = {}
    render() {
        return (
            <div className="contentRoutesContainer">
                <span className="tituloPage">Sobre o Sistema</span>
                <div className="divider-page1" />

                <div style={{ fontSize: 20, marginTop: 40 }}>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;O FastGestor é um sistema ERP completo e fácil de usar, projetado especificamente para atender as necessidades do MEI, micros e pequenas empresas.
                </div>
                <div style={{ fontSize: 20, marginTop: 30 }}>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Com suas vendas, estoque, financeiro, ordens de serviços e relatórios gerenciais, o FastGestor oferece tudo o que você precisa para gerenciar seus negócios de maneira eficiente e eficaz.
                </div>
                <div style={{ fontSize: 20, marginTop: 30 }}>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Este ERP foi desenvolvido com tecnologias de última geração, interfaces amigáveis e segurança avançada, garantindo a integridade e a privacidade das informações do seu negócio.
                </div>
                <div style={{ fontSize: 20, marginTop: 30 }}>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Com uma série de recursos personalizáveis, este sistema é especialmente adequado para microempreendedores individuais, micro e pequenas empresas do comércio, oferecendo soluções adaptáveis para diferentes modelos de negócios. Ele oferece uma ampla gama de relatórios gerenciais para ajudar a monitorar e aprimorar a performance do negócio, além de recursos de automação para reduzir o tempo gasto em tarefas administrativas.
                </div>
                <div style={{ fontSize: 20, marginTop: 30 }}>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Mas, o que torna o FastGestor diferente dos outros sistemas ERP no mercado? O FastGestor não é apenas um software, é uma solução completa que foi desenvolvida com base nas necessidades e desafios que as MEIs, micro e pequenas empresas enfrentam no dia a dia.
                </div>
                <div style={{ fontSize: 20, marginTop: 30 }}>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Com o FastGestor, você pode ter total controle sobre seus negócios, melhorando sua produtividade e aumentando suas vendas. Além disso, sua interface intuitiva e fácil de usar torna a gestão de seus negócios mais simples e prática do que nunca.
                </div>
                <div style={{ fontSize: 20, marginTop: 30 }}>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Em resumo, o FastGestor é um sistema ERP completo e altamente especializado, projetado para ajudar empresas do comércio a otimizar seus processos e aumentar sua eficiência operacional.
                </div>
                <div style={{ fontSize: 20, marginTop: 80 }}>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Não espere mais, adquira o FastGestor agora mesmo e faça seus negócios decolarem!
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/SobrePage.js